<template>
<div>
    <b-container>
        <b-row>
            <b-col cols="12" class="column">
                <p class="para">
                    When investing in a B11 NFT, you’re not just purchasing a provably-rare piece of art or a rare NFT. You're becoming a member of an exclusive community and gain membership access to a private club whose benefits and possibilities will increase over a period of time. Surround yourself with minds that are part of the innovative elite digital movement and a club of members that see the world in a different way. A B11 NFT can open many digital and real-world doors for you and can serve as your digital identity, declaring to the world that you are part of the pioneering digital movement!
                </p>
            </b-col>
        </b-row>
        <br><br>
        <b-row id="Team">
            <b-col cols="12" class="column">
                <h2 class="heading">Friends Of B11</h2>
                <br><br>
                <b-card
                    title="B11's Dad"
                    :img-src="require('../../assets/Team/team.png')"
                    img-alt="Image"
                    img-top
                    style="max-width: 30vh;"
                    class="mb-2"
                >
                    <b-card-text>
                    Founder
                    </b-card-text>

                    <a class="socials" href="https://twitter.com/sevbelford/" target="_blank"><b-icon class="icons" icon="twitter" font-scale="2"></b-icon></a>
                    &nbsp;&nbsp;
                    <a class="socials" href="https://www.instagram.com/sevbelford/" target="_blank"><b-icon class="icons" icon="instagram" font-scale="2"></b-icon></a>
                </b-card>


                <b-card
                    title="B11's Tech Guy"
                    :img-src="require('../../assets/Team/team3.png')"
                    img-alt="Image"
                    img-top
                    style="max-width: 30vh;"
                    class="mb-2"
                >
                    <b-card-text >
                    Dev
                    </b-card-text>

                    <a class="socials" href="https://twitter.com/Official_Chonii" target="_blank"><b-icon class="icons" icon="twitter" font-scale="2"></b-icon></a>
                </b-card>
            </b-col>
        </b-row>
        <br><br>
        <b-row>
            <b-col cols="12" class="column">
                <h2 class="para">A word from B11’s dad:</h2>
                <div class="note">  
                    NFT’s should never be just about money, they should be about art and creativity in all shapes and forms, opening up the possibility to endless inventiveness and artistry involving the community, project, and founders.
                    Our goal is to pioneer and achieve linking of the virtual world and the real world. A morphed new reality, creating tangible and verifiable long-term benefits for the members and supporters of our community.
                </div>
            </b-col>
        </b-row>
    </b-container>
</div>
</template>

<script>
export default {
    name: "Team"
}
</script>

<style scoped>
.icons
{
    color: white
}
@import url('https://fonts.googleapis.com/css?family=Indie+Flower');
div.note {
	 position: relative;
	 padding: 40px;
	 background: #fff url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAgCAYAAABU1PscAAAEr0lEQVRYhW2Yy5FkIQwE5YBueIMPmIM3GIE3eMMeepPJVvRhY3veB0qlUkm8OOfkGCNba3nOyTlnzjlzjJFrrdx7Z2st55zZe885Z7bWcu+d994cY2REZO/9XV9rZe89xxg558xzTt57c86Ze++vfVhzrZUR8fbae2fvPXvvGRG51srWWt57v/AEi997c++dEfFurrXe73vv2xiwBDPGeM+31l5APNt7/wps7/1AQxz/33tf8BB0znlEQgSkR0T8zEBr7YE457xgCJLn11rvHhudc/Kc88BW1scYLzsA4zkCIwgysdZ6AXJ9zpnhNAGal2GotfYlJ0BHxAMN2N77CwyQEASbBEKmCJD9q4xgHmwQdM7JMMOWDVHyN5kCDJtExNMlQB47/+VYZWCQZhdwJg1iWRPgqCR42MXs4kL/sOEUW8ewCvAK0JuTGVjlukFSlwTh9XkmIj4ZsP5gAslYGk6lncWMuTDJjIOA7QqEa64JsmFsEfGVlUA+bAgIOw6F6yKlTrhux/J71S655gwRMOsTBNdsMMZ2zvkEgPVR4bZIAgM0gAFvMC5oX6cOnK0qSUvTtWKZuuAfsVQ2L1dp4CakDglVfcMMwdHoYBSmIYV9kSUGwT2vyd6W1asPp7E2ocooUvIGe++XNTcyOxVBQcbTb8lgNRDepeCd0Wf/pLdam53CQOwEBl27rlnmGgz/sly7j8l0YduSyVjwIEGgcZh2W2chFiGNdiozZC8HGGsRRLVbpIKcTaRVwd9Baq1tjxZoGKCwAsMGycIETk9wNgwO8jymVEsH6C+zaK19XIhF+M3CrnacCPat5zpl2gTIrIPwfaRVMdidbASW4Forow5jHhVseWbYTmCWcB87jYPgt4vRIwTrm0AXeG2ue+9PEbtQ7DxonGcAzDPYm3XuHuBmBJg6CDIyUHNuig7KQ6cxhhtS1bUZdWf1DG/mq1RsBNV9zKIPTybhDWwaJF2fa62PC1ln9TBipt1oPMP7neoY7qQuPmeGYicAO5FJsa2/afiXL3vOgWHkU1NIduohxhomc36uTq8AQ2KeiepEimzfKGEd1xdd8bZBWAZUdQs7idNOQbtO3KDeQUUTqu/XOSvsAN7YBevqt3ysxXostf36PXpOrSf2cCZNDgHZteacfzXgkcIjLAtXJtA4TmJAnp1s0+68rh0fmAyS53y/BhX4ufVXu59nDwfpTx0uWGvYI4StkRpz4PVkaAnVeUs1+Tem+rDgc2r9YlCPeLZY1sK56pDmDvvL1fysa8ISZJ85Z4Z91yD49zX5yerwfjsNLOJi7uTuJx4hbAjVxcicj6oeBHvvGW4staHVFu7frhPP8PWo6D7gSdZHSWrF2be51NH9qz/5MOMirDOJde2GxLgBm/6e5BMXmYUozzRcI7M+Ifqk5pH9fUk04Ncc1KzczFyUzpK/Enj4A7zdx4H55AdwN72Ko44aa62/GqjMEiUvuqO6qHnOWoYMa9VgvQ9kuBtjAO7aXLdJrLU+NYDFeZ7hYX/E8uIeL+pwZ68nAz4r1C91VW7gqZL2qZF6Chb2YZtFPe+7oAjWBelTXbU9Z9QOVKdN1uD/rw9YOrm5M/8DNoCiyP8tLEcAAAAASUVORK5CYII=');
	 max-width: 100vh;
	 margin: 10px auto 40px;
	 box-shadow: 0 1px 6px rgba(0, 0, 0, 0.05);
	 font-family: 'Indie Flower', cursive;
	 font-size: 1.5em;
	 color: #229;
}
 div.note::after {
	 display: block;
	 content: " ";
	 position: absolute;
	 left: 0;
	 bottom: -2px;
	 width: 100%;
	 height: 3px;
	 background: #fff url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAgCAYAAABU1PscAAAEr0lEQVRYhW2Yy5FkIQwE5YBueIMPmIM3GIE3eMMeepPJVvRhY3veB0qlUkm8OOfkGCNba3nOyTlnzjlzjJFrrdx7Z2st55zZe885Z7bWcu+d994cY2REZO/9XV9rZe89xxg558xzTt57c86Ze++vfVhzrZUR8fbae2fvPXvvGRG51srWWt57v/AEi997c++dEfFurrXe73vv2xiwBDPGeM+31l5APNt7/wps7/1AQxz/33tf8BB0znlEQgSkR0T8zEBr7YE457xgCJLn11rvHhudc/Kc88BW1scYLzsA4zkCIwgysdZ6AXJ9zpnhNAGal2GotfYlJ0BHxAMN2N77CwyQEASbBEKmCJD9q4xgHmwQdM7JMMOWDVHyN5kCDJtExNMlQB47/+VYZWCQZhdwJg1iWRPgqCR42MXs4kL/sOEUW8ewCvAK0JuTGVjlukFSlwTh9XkmIj4ZsP5gAslYGk6lncWMuTDJjIOA7QqEa64JsmFsEfGVlUA+bAgIOw6F6yKlTrhux/J71S655gwRMOsTBNdsMMZ2zvkEgPVR4bZIAgM0gAFvMC5oX6cOnK0qSUvTtWKZuuAfsVQ2L1dp4CakDglVfcMMwdHoYBSmIYV9kSUGwT2vyd6W1asPp7E2ocooUvIGe++XNTcyOxVBQcbTb8lgNRDepeCd0Wf/pLdam53CQOwEBl27rlnmGgz/sly7j8l0YduSyVjwIEGgcZh2W2chFiGNdiozZC8HGGsRRLVbpIKcTaRVwd9Baq1tjxZoGKCwAsMGycIETk9wNgwO8jymVEsH6C+zaK19XIhF+M3CrnacCPat5zpl2gTIrIPwfaRVMdidbASW4Forow5jHhVseWbYTmCWcB87jYPgt4vRIwTrm0AXeG2ue+9PEbtQ7DxonGcAzDPYm3XuHuBmBJg6CDIyUHNuig7KQ6cxhhtS1bUZdWf1DG/mq1RsBNV9zKIPTybhDWwaJF2fa62PC1ln9TBipt1oPMP7neoY7qQuPmeGYicAO5FJsa2/afiXL3vOgWHkU1NIduohxhomc36uTq8AQ2KeiepEimzfKGEd1xdd8bZBWAZUdQs7idNOQbtO3KDeQUUTqu/XOSvsAN7YBevqt3ysxXostf36PXpOrSf2cCZNDgHZteacfzXgkcIjLAtXJtA4TmJAnp1s0+68rh0fmAyS53y/BhX4ufVXu59nDwfpTx0uWGvYI4StkRpz4PVkaAnVeUs1+Tem+rDgc2r9YlCPeLZY1sK56pDmDvvL1fysa8ISZJ85Z4Z91yD49zX5yerwfjsNLOJi7uTuJx4hbAjVxcicj6oeBHvvGW4staHVFu7frhPP8PWo6D7gSdZHSWrF2be51NH9qz/5MOMirDOJde2GxLgBm/6e5BMXmYUozzRcI7M+Ifqk5pH9fUk04Ncc1KzczFyUzpK/Enj4A7zdx4H55AdwN72Ko44aa62/GqjMEiUvuqO6qHnOWoYMa9VgvQ9kuBtjAO7aXLdJrLU+NYDFeZ7hYX/E8uIeL+pwZ68nAz4r1C91VW7gqZL2qZF6Chb2YZtFPe+7oAjWBelTXbU9Z9QOVKdN1uD/rw9YOrm5M/8DNoCiyP8tLEcAAAAASUVORK5CYII=');
	 box-shadow: 0 3px 6px rgba(0, 0, 0, 0.2);
	 -webkit-clip-path: polygon(0% 0%, 5% 70%, 10% 0%, 15% 100%, 20% 0%, 25% 45%, 30% 0%, 35% 100%, 40% 0%, 45% 60%, 50% 0%, 55% 100%, 60% 0%, 65% 100%, 70% 0%, 75% 100%, 80% 0%, 85% 100%, 90% 0%, 95% 50%, 100% 0%);
	 clip-path: polygon(0% 0%, 5% 70%, 10% 0%, 15% 100%, 20% 0%, 25% 45%, 30% 0%, 35% 100%, 40% 0%, 45% 60%, 50% 0%, 55% 100%, 60% 0%, 65% 100%, 70% 0%, 75% 100%, 80% 0%, 85% 100%, 90% 0%, 95% 50%, 100% 0%);
}
 div.note.rough::after {
	 bottom: -6px;
	 height: 6px;
}
.column
{
    margin-bottom: 5vh;
    margin-top: 10vh;
}
.socials
{
    width: 15%;
}
.socialsInsta
{
    width: 12%;
}
.heading
{
    color: white;
    font-size: 5vh;
    font-style: italic;
    text-transform: uppercase;
    font-weight: bold;
}
.card
{
    display:inline-block !important; 
    background: transparent;
    
}
.card-title{
    color: white !important;
    font-size: 3vh;
}
.card-text 
{
    color: white !important;
    font-size: 2vh;
}

.para
{
    color: white !important;
    font-size: 2vh;
    text-transform: uppercase;
}
</style>


// WEBPACK FOOTER //
// src/components/HomeComp/Team.vue